
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefcorner",
      function () {
        return require("private-next-pages/debtreliefcorner/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefcorner"])
      });
    }
  